module.exports = __webpack_public_path__ + "static/img/exam-province.f18a98b7.png";